const _temp0 = require("./icons/chat_arrow.svg");
const _temp1 = require("./icons/expand.svg");
const _temp2 = require("./icons/maximize.svg");
const _temp3 = require("./icons/minimize.svg");
module.exports = {
  "chat_arrow": _temp0,
  "expand": _temp1,
  "maximize": _temp2,
  "minimize": _temp3
}